import React, { useState } from "react";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import "./direct.css";
import Swal from "sweetalert2";
import { FaTrashAlt, FaPlus } from "react-icons/fa";
import axios from "axios";
import ContenedoresActivos from "./contentAcvites";


function Direct({ masterNumber, dataMaster, onBack }) {

  const {
    master,
    merchandise_types,
    booking_flights

  } = dataMaster;

  const [rowErrors, setRowErrors] = useState([]);
  const currentYear = new Date().getFullYear();
  const [rows, setRows] = useState(booking_flights);

  const anioOptions = Array.from(
    { length: new Date().getFullYear() + 2 - 2019 }, // Este cálculo genera el número de años desde 2019 hasta el año actual + 1
    (_, i) => 2019 + i
  );

  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };

  const handleAddRow = () => {
    setRows([...rows, { flight: "", year: currentYear.toString(), time: "" }]);
  };

  const [formData, setFormData] = useState({
    master: master.master,
    origenInicial: master.origin,
    origen: master.final_origin,
    destino: master.destiny,
    destinoFinal: master.final_destination,
    piezas: master.pieces,
    grossWeight: master.weight,
    chargeableWeight: master.chargeable_weight,
    volumen: master.volume,
    tipo: master.merchandise_type,
    descripcion: master.description,
  });

  const [formErrors, setFormErrors] = useState({});

  const handleRowInputChange = (index, field, value) => {
    const updatedRows = [...rows];

    if (field === "vuelo") {
      value = value.toUpperCase();

      // Si no contiene la diagonal pero tiene más de 2 caracteres (mínimo aerolínea + número)
      if (!value.includes("/") && value.length > 2) {
        const letras = value.slice(0, 2);
        const numerosYFecha = value.slice(2);

        const match = numerosYFecha.match(/^(\d{1,4})(\d{0,2}[A-Z]*)$/);
        if (match) {
          const numero = match[1].padStart(4, "0");
          const fecha = match[2];
          value = `${letras}${numero}/${fecha}`;
        }
      }

      // Oculta el error si empieza a ingresar un valor válido
      if (value.length > 0 && rowErrors[index]?.vuelo) {
        const updatedErrors = [...rowErrors];
        updatedErrors[index] = {
          ...updatedErrors[index],
          vuelo: "", // limpia solo el error de vuelo
        };

        if (field === "hora" && value.trim() !== "" && rowErrors[index]?.hora) {
          const updatedErrors = [...rowErrors];
          updatedErrors[index] = {
            ...updatedErrors[index],
            hora: "", // limpia solo el error de hora
          };
        }

        setRowErrors(updatedErrors);
      }
    }

    updatedRows[index][field] = value;
    setRows(updatedRows);
  };

  const handleInputChange = (field, value) => {
    let newValue = value;

    const threeLetterFields = ["origenInicial", "origen", "destino", "destinoFinal"];
    if (threeLetterFields.includes(field)) {
      newValue = newValue.toUpperCase().replace(/[^A-Z]/g, "");
      if (newValue.length > 3) newValue = newValue.slice(0, 3);
    }

    if (field === "piezas") {
      if (!/^\d*$/.test(newValue)) return;
    }

    const floatFields = ["grossWeight", "chargeableWeight", "volumen"];
    if (floatFields.includes(field)) {
      if (!/^\d*\.?\d*$/.test(newValue)) return;
    }

    setFormData((prev) => ({ ...prev, [field]: newValue }));

    if (formErrors[field]) {
      setFormErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const eliminarAlert = () => {
    Swal.fire({
      title: `¿Quieres eliminar la master ${master.master}?`,
      text: "",
      html: '<div class="alert-text">Esta acción es irreversible</div>',
      iconColor: "#ED1B1B",
      customClass: {
        confirmButton: "btn-amc-blue",
        cancelButton: "btn-amc-pink",
        title: "alert-title",
        popup: "alert-bg",
      },
      showCancelButton: true,
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const params = {
          master_id: master.id,
        };

        try {
          const response = await axios.delete(
            `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/delete_exp_master`,
            {
              params: params,
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token") || ""
                  }`,
              },
            }
          );

          if (response.data.error === false) {
            Swal.fire({
              title: "¡Eliminado!",
              text: `${response.data.body.message}`,
              icon: "success",
              iconColor: "#1B9925",
              customClass: {
                confirmButton: "btn-ok",
                title: "alert-title",
                popup: "alert-bg",
              },
            }).then(() => {
              onBack(); 
            });
          }
        } catch (error) {
          Swal.fire("Error", "Hubo un error al obtener los datos", "error");
        }
      }
    });
  };

  const guardarAlert = async () => {
    const errors = {};
    const requiredFields = [
      "origenInicial",
      "origen",
      "piezas",
      "destino",
      "destinoFinal",
      "grossWeight",
      "chargeableWeight",
      "volumen",
      "tipo",
      "descripcion",
    ];

    // Validar campos individuales del formulario
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].toString().trim() === "") {
        errors[field] = "Este campo es obligatorio";
      }
    });

    // Validar campos de cada fila en rows (vuelo, anio, hora)
    const rowErrors = rows.map((row) => {
      const err = {};
      if (!row.flight || row.flight.trim() === "")
        err.flight = "Este campo es obligatorio";
      if (!row.year || row.year.toString().trim() === "")
        err.year = "Este campo es obligatorio";
      if (!row.time || row.time.trim() === "")
        err.time = "Este campo es obligatorio";
      return err;
    });

    // Verifica si hay errores en filas
    const hayErroresEnRows = rowErrors.some(
      (rowErr) => Object.keys(rowErr).length > 0
    );

    if (Object.keys(errors).length > 0 || hayErroresEnRows) {
      setFormErrors(errors); // esto debería usarse en los inputs del form
      setRowErrors(rowErrors); // deberías tener esto en cada fila de tu tabla
      Swal.fire({
        title: "Faltan datos",
        text: "Por favor, completa todos los campos obligatorios.",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    //Validacion y formato del vuelo
    const vueloRegex = /^[A-Z]{2}\d{4}\/\d{2}[A-Z]{3}$/;
    const vuelos = rows.map((row) => row.flight.trim().toUpperCase());

    const vuelosConFormato = vuelos.map((v) => {
      // Autocompletado: LL123/24APR => LL0123/24APR
      const [aerolineaYNumero, fecha] = v.split("/");
      if (!aerolineaYNumero || !fecha) return v;

      const letras = aerolineaYNumero.slice(0, 2).toUpperCase();
      const numeros = aerolineaYNumero.slice(2).padStart(4, "0");
      return `${letras}${numeros}/${fecha.toUpperCase()}`;
    });

    // Validación de formato y duplicados
    const vuelosInvalidos = vuelosConFormato.filter((v) => !vueloRegex.test(v));
    const vuelosDuplicados = vuelosConFormato.filter(
      (v, i, self) => self.indexOf(v) !== i
    );

    if (vuelosInvalidos.length > 0) {
      Swal.fire({
        title: "Formato de vuelo inválido",
        text: `Verifica el/los vuelo(s): ${vuelosInvalidos.join(", ")}`,
        icon: "error",
        iconColor: "#ED1B1B",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    if (vuelosDuplicados.length > 0) {
      Swal.fire({
        title: "Vuelos Duplicados",
        text: `Los siguientes vuelos estan repetidos: ${vuelosDuplicados.join(
          ", "
        )}`,
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    const fieldMap = {
      origenInicial: "origin",
      origen: "final_origin",
      piezas: "pieces",
      destino: "destiny",
      destinoFinal: "final_destination",
      grossWeight: "weight",
      chargeableWeight: "chargeable_weight",
      volumen: "volume",
      tipo: "merchandise_type",
      descripcion: "description",
      // agrega más campos si es necesario
    };

    // Crear una copia de formData con los nombres renombrados según fieldMap
    const formDataRenombrado = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => [
        fieldMap[key] || key,
        value,
      ])
    );

    // Construir datos finales combinando los datos renombrados con los vuelos
    const datosFinales = {
      ...formDataRenombrado,
      flight: rows.map((row, index) => vuelosConFormato[index]),
      year: rows.map((row) => row.year),
      time: rows.map((row) => row.time),
    };
    const user_id = JSON.parse(localStorage.getItem("user"))?.id;
    // Si necesitas agregar más campos
    datosFinales.master_id = master.id;
    datosFinales.user_id = user_id;

    const params = datosFinales;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_upd/upd_save/1`,
        params,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
          },
        }
      );

      if (response.data.error === false) {
        Swal.fire({
          title: "Guardado",
          text: "Los datos han sido guardados correctamente.",
          icon: "success",
          iconColor: "#1B9925",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const handleRedirectToPreCapture = () => {
  };

  return (
    <>
      <Helmet>
        <title>Horus | Búsqueda master</title>
      </Helmet>
      <ScrollToTop />

      <div className="container-fluid">
        <>
          {/* Botones Cont. activos y eliminar guía*/}
          <div className="row mb-3">
            <div className="col-12 text-end">

              {Number(formData.tipo) === 19 ? (
                <ContenedoresActivos id={dataMaster.master.id} />
              ) : ""}

              <button
                className="btn btn-amc-pink botonEliminar"
                onClick={eliminarAlert}
              >
                Eliminar guía
              </button>
            </div>
          </div>

          {/* textos e inputs */}
          <div className="row mb-4">
            {[
              { label: "Master", key: "master" },
              { label: "Origen inicial", key: "origenInicial" },
              { label: "Origen", key: "origen" },
              { label: "Destino", key: "destino" },
              { label: "Destino final", key: "destinoFinal" },
              { label: "Piezas Master", key: "piezas" },
              { label: "Gross Weight Master", key: "grossWeight" },
              { label: "Chargeable Weight Master", key: "chargeableWeight" },
              { label: "Volumen Master", key: "volumen" },
              { label: "Tipo de mercancia", key: "tipo" },
              { label: "Descripción Master", key: "descripcion" },
            ].map((item, index) => {
              const isReadOnly = [0].includes(index);

              return (
                <div key={index} className="col-md-4 mb-3">
                  <label className="form-label fw-bold">{item.label}</label>

                  {item.key === "tipo" ? (
                    <>
                      <select
                        className="form-select"
                        value={formData.tipo}
                        onChange={(e) => handleInputChange("tipo", e.target.value)}
                      >
                        {merchandise_types.map((type) => (
                          <option key={type.id} value={type.id}>
                            {type.name}
                          </option>
                        ))}
                      </select>
                      {formErrors.tipo && (
                        <small className="text-danger">{formErrors.tipo}</small>
                      )}
                    </>
                  ) : item.key === "descripcion" ? (
                    <>
                      <textarea
                        className="form-control"
                        rows="2"
                        value={formData.descripcion}
                        onChange={(e) =>
                          handleInputChange("descripcion", e.target.value)
                        }
                      />
                      {formErrors.descripcion && (
                        <small className="text-danger">
                          {formErrors.descripcion}
                        </small>
                      )}
                    </>
                  ) : (
                    <>
                      <input
                        type="text"
                        className={`form-control ${isReadOnly ? "fondoInput" : ""
                          }`}
                        readOnly={isReadOnly}
                        value={formData[item.key]}
                        onChange={(e) =>
                          handleInputChange(item.key, e.target.value)
                        }
                      />
                      {formErrors[item.key] && (
                        <small className="text-danger">
                          {formErrors[item.key]}
                        </small>
                      )}
                    </>
                  )}
                </div>
              );
            })}
          </div>

          {/* Tabla con filas dinamicas */}
          <div className="row mt-4 mb-4">
            <div className="col-md-12">
              <table className="table mx-auto" style={{ maxWidth: "800px", width: "100%" }}>
                <thead className="table-light fondo-headUPD">
                  <tr>
                    <th>* Vuelo</th>
                    <th>* Año</th>
                    <th>* Hora Vuelo</th>
                    <th>Eliminar</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className={`form-control ${rowErrors[index]?.flight ? "is-invalid" : ""
                            }`}
                          value={row.flight}
                          onChange={(e) =>
                            handleRowInputChange(
                              index,
                              "flight",
                              e.target.value
                            )
                          }
                        />
                        {rowErrors[index]?.flight && (
                          <div className="invalid-feedback">
                            {rowErrors[index].flight}
                          </div>
                        )}
                      </td>
                      <td>
                        <select
                          className={`form-select ${rowErrors[index]?.year ? "is-invalid" : ""
                            }`}
                          value={row.year}
                          onChange={(e) =>
                            handleRowInputChange(
                              index,
                              "anio",
                              e.target.value
                            )
                          }
                        >
                          {anioOptions.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                        {rowErrors[index]?.year && (
                          <div className="invalid-feedback">
                            {rowErrors[index].year}
                          </div>
                        )}
                      </td>
                      <td>
                        <input
                          type="time"
                          className={`form-control ${rowErrors[index]?.time ? "is-invalid" : ""
                            }`}
                          value={row.time}
                          onChange={(e) =>
                            handleRowInputChange(
                              index,
                              "time",
                              e.target.value
                            )
                          }
                        />
                        {rowErrors[index]?.time && (
                          <div className="invalid-feedback">
                            {rowErrors[index].time}
                          </div>
                        )}
                      </td>
                      <td className="text-center">
                        <button
                          className="btn iconoTrash"
                          onClick={() => handleDeleteRow(index)}
                        >
                          <FaTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="text-center mt-3">
                <button className="btnn" onClick={handleAddRow}>
                  <FaPlus />
                </button>
              </div>
            </div>
          </div>

          {/* Botón Guardar */}
          <div className="row mb-3">
            <div className="col text-end">
              <button className="btnn" onClick={guardarAlert}>
                Guardar
              </button>
            </div>
          </div>

          {/* Enlace a otra vista */}
          <div className="row">
            <div className="col text-end">
              <button
                type="button"
                onClick={handleRedirectToPreCapture}
                rel="noopener noreferrer"
                className="btn p-0 m-0 botonIr"
              >
                Ir a precaptura de la guía 123-12345678
              </button>
            </div>
          </div>
        </>

      </div>
    </>
  );
}
export default Direct;
